<template>
    <fieldset :class="[`rounded-md block transition`, {'mb-8': !no_mb}, color_class, padding_class_local]">
        <div v-if="heading || subheading" class="mb-8">
            <h3 v-if="heading" class="text-lg leading-6 font-medium text-gray-900">{{ heading }}</h3>
            <p v-if="subheading" class="mt-1 max-w-2xl text-sm text-gray-500">{{ subheading }}</p>
        </div>
        <slot></slot>
    </fieldset>
</template>

<script>
import { computed } from 'vue'
export default {
    props: ['heading','subheading', 'class', 'no_mb', 'color', 'padding_class'],
    setup(props) {

        const padding_class_local = computed(() => {
            return !props.padding_class
                ? 'p-6'
                : props.padding_class
        })

        const color_class = computed(() => {

            if (typeof props.color === 'string' && props.color.includes('bg-')) return props.color

            return !props.color
                ? 'bg-gray-50'
                : `bg-${props.color}-50`
        })

        return {
            color_class,
            padding_class_local
        }
    },
}
</script>